import { RESET_ALL_PMS_UPDATES, RESET_PMS_UPDATE_DETAILS, SAVE_ALL_PMS_UPDATES, SAVE_PMS_UPDATE_DETAILS } from "../types";

const INITIAL_STATE = {
    pmsUpdates: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 50,
    },
    pmsUpdateDetails: {},
};

const pmsReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case SAVE_ALL_PMS_UPDATES:
            return {
                ...state,
                pmsUpdates: {
                    pageSize: 10,
                    ...payload,
                },
            };

        case RESET_ALL_PMS_UPDATES:
            return {
                ...state,
                pmsUpdates: INITIAL_STATE.pmsUpdates,
            };

        case SAVE_PMS_UPDATE_DETAILS:
            return {
                ...state,
                pmsUpdateDetails: payload
            };

        case RESET_PMS_UPDATE_DETAILS:
            return {
                ...state,
                pmsUpdateDetails: INITIAL_STATE.pmsUpdateDetails,
            };

        default:
            return state;
    }
};

export default pmsReducer;
